import React from "react";
import { makeStyles } from "@mui/styles";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import { Button, Grid, Hidden, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SOCIAL } from "../../../app/api/routes";

const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: TOP_PADDING,
    paddingBottom: SIDE_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    backgroundColor: theme.palette.primary.main,
  },
  bloglabeltxt: {
    fontSize: 25,
  },
  cardWrapper: {
    borderWidth: 2,
    borderStyle: "solid",
    borderRadius: 5,
    borderColor: theme.palette.secondary.main,
  },
  projectimg: {
    width: "100%",
  },
  projectdesc: {
    padding: "3% 5% 5% 5%",
    fontSize: 18,
  },
}));

const SocialInitiatives = (props) => {
  const classes = usestyles();
  const navigate = useNavigate();

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} md={3}>
        <Typography className={classes.bloglabeltxt}>
          Social Initiatives__
        </Typography>
      </Grid>
      <Grid item xs={12} md={9} container spacing={3}>
        <Grid item xs={12} md={6}>
          <div className={classes.cardWrapper}>
            <img
              src="/images/projectposh.svg"
              className={classes.projectimg}
              alt="proj"
            />
            <Typography className={classes.projectdesc} variant={"h5"}>
              Project POSH+ is an international initiative for prevention of
              sexual harassment and gender discrimination, having its presence
              in eight countries across Asia, Europe and Africa.
            </Typography>
            <Hidden mdUp>
              <br />
              <br />

              <Button
                style={{
                  margin: "3%",
                }}
                onClick={() => {
                  navigate(SOCIAL);
                }}
              >
                Learn More ->
              </Button>
            </Hidden>
          </div>
          <Hidden mdDown>
            <br />
            <br />

            <Button
              onClick={() => {
                navigate(SOCIAL);
              }}
            >
              Learn More ->
            </Button>
          </Hidden>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={classes.cardWrapper}>
            <img
              src="/images/projectlr.svg"
              className={classes.projectimg}
              alt="proj"
            />
            <Typography className={classes.projectdesc} variant={"h5"}>
              LegalRaksha is a powerful legal assistance service for Women and
              LGBTQ+. LegalRaksha eliminates the barriers that prevent women and
              LGBTQ+ from availing professional legal consultation and empowers
              them to protect their fundamental rights.
            </Typography>
            <Hidden mdUp>
              <br />
              <Button
                style={{
                  margin: "3%",
                }}
                onClick={() => {
                  navigate(SOCIAL);
                }}
              >
                Learn More ->
              </Button>
            </Hidden>
          </div>
          <Hidden mdDown>
            <br />
            <Button
              onClick={() => {
                navigate(SOCIAL);
              }}
            >
              Learn More ->
            </Button>
          </Hidden>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SocialInitiatives;
